import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import moment from 'moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import {checkAuthentication} from '../../utils';

export default function EditCostCenterDialog({ handleEditAmendmentCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
	const [LockedAlert, setAlert] = React.useState(false);

    const [poChoices, setPoChoices] = React.useState([
        { label: 'Test PO A', value: 'testPo1' },
        { label: 'Test PO B', value: 'testPo2' },
    ])

    const initialValues = {
        poid: data.POID,
        amount:  parseFloat(data.Amount).toFixed(2),
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),    
    };

    const validFormSchema = Yup.object({
        poid: Yup
            .string("Choose a PO type")
            .required("PoID required"),        
        amount: Yup.number().test(
            'is-Currency',
            'invalid Currency',
            value => (value.toFixed(2) + "").match(/^[+-]?[0-9]{1,3}(?:[0-9]*(?:[.,][0-9]{2})?|(?:,[0-9]{3})*(?:\.[0-9]{2})?|(?:\.[0-9]{3})*(?:,[0-9]{2})?)$/),
        ),
        start: Yup
            .date("Enter a start date for the amendment mm/dd/yyyy")
            .required("Start date required mm/dd/yyyy"),
        end: Yup
            .date("Enter an end date for the amendment mm/dd/yyyy")
            .required("End date required mm/dd/yyyy"),        

    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            POID: values.poid,            
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            Amount: parseFloat(values.amount).toFixed(2),

        };
		if( ( moment.utc(values.start)>moment.utc(values.end))){
					setAlert(true);
				} else {
        handleEditAmendmentCallback(msg);              
        handleClose();
        }
    })

    const handleAlertClose = () => {
	        setAlert(false);
	    };
	    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPoChoices(choices)
    }

    React.useEffect(() => {
		if (open){
		checkAuthentication();
		}
        if (refresh) {

            fetch('api/PO', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json))

            setRefresh(false);
        }
    })

    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                Edit
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <DialogTitle>Amendment Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-sow">PO</InputLabel>
                                        <CustomSelect
                                            name="poid"
                                            id="outlined-sow"
                                            options={poChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.poid}
                                            error={props.touched.poid && Boolean(props.errors.poid)}
                                            helperText={props.touched.poid && props.errors.poid}
                                            label="SOW"
                                        />
                                    </FormControl>
                                </div>                               
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name="start"
                                            id="outlined-startDate"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.start}
                                            error={props.touched.start && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start Date"
                                        />
                                    </FormControl>
                    
                                    <FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name="end"
                                            id="outlined-endDate"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.end}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End Date"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>                                        
                                        <TextField
                                            name="amount"
                                            id="outlined-amendmentAmount"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.amount}
                                            error={props.touched.amount && Boolean(props.errors.amount)}
                                            helperText={props.touched.amount && props.errors.amount}
                                            label="Amendment Amount"
                                        />
                                    </FormControl>
                    
                                </div>
                                <DialogActions>
                                    <Button onClick={handleClose}>Cancel</Button>
                                    <Button onClick={props.handleSubmit}>Save</Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>   
                 <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {"Start Date should be before the End Date, Please enter different time period"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>                      
            </Dialog></MuiThemeProvider>
        </div>
    );
}